/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 专题演出列表
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  productsCondition: good.SubjectProductsCondition,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.Page<good.RecommendProductDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/good/subject-products`,
    data: productsCondition,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
